import {createContext} from 'react'

type OctocaptchaContextValue = {
  /**
   * The hostname of the octocaptcha instance to use, e.g. "octocaptcha.com"
   */
  hostName: string

  /**
   * Octocaptcha uses the `origin_page` parameter to load the right configuration
   * (e.g. api keys, feature flags, metrics, etc.).
   */
  originPage?: string

  /**
   * The language/locale to use for the captcha widget (e.g. 'en-us', 'ja').
   */
  locale?: string

  /**
   * When true, the iframe loads the DataDome endpoint (/datadome) instead of the
   * Arkose endpoint (/). This enables DataDome signal collection and cookie relay.
   */
  datadomeCaptchaEnabled?: boolean
}

export const OctocaptchaContext = createContext<OctocaptchaContextValue>({hostName: ''})
